import moment from 'moment';

export default {
  getTodName: (todNumber: number) => {
    const todName: any = {
      1: 'Breakfast',
      2: 'Lunch',
      3: 'Dinner',
      4: 'Snacks'
    };
    return todName[todNumber];
  },
  getDateString: (date: string) => {
      return moment(date).format('MMMM Do, YYYY');
  }
};
